import { useEffect } from 'react'
import { Container, makeStyles, Paper, Typography } from '@material-ui/core'
import { useParams } from 'react-router-dom'
import { FC, useRef, useState } from 'react'
import useTranslate from '../i18n/useTranslate'
import Form from '../component/um/setting-consideration/Form'
import { useHistory } from 'react-router-dom'
import { ConsiderationFormType, useSettingConsideration } from '../services/um/useSettingConsideration'
import Dialog, { DialogType } from '../control/dialog/dialog'
import useAuthenStore from '../stores/authen/authenStore'
interface SettingConsiderationEditProps {}

const SettingConsiderationEdit: FC<SettingConsiderationEditProps> = ({}) => {
    const classes = useStyle()
    const authenStore = useAuthenStore()
    const translate = useTranslate()
    const history = useHistory()
    const params = useParams<{ id: string }>()

    const irb = useRef<number | undefined>((authenStore?.profile?.irb && authenStore.profile.irb) || undefined)

    const { settingConsideration, putSettingConsideration } = useSettingConsideration({
        id: params.id,
        irb: (irb.current && irb.current.toString()) || undefined,
    })

    const [configDialog, setConfigDialog] =
        useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogTwoRef = useRef<Record<string, Function>>()
    const onRefDialogTwo = (func: Record<string, Function>) => {
        dialogTwoRef.current = func
    }

    useEffect(() => {
        //don't set state here
        irb.current = (authenStore?.profile?.irb && authenStore.profile.irb) || undefined
    })

    const save = async (values: ConsiderationFormType) => {
        const result = await putSettingConsideration(values, params.id, (irb.current && irb.current.toString()) || '')
        if (result) {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                content: translate.get('ALERT.CONTENT.SAVE_SUCCESS'),
                type: 'alert-message',
                onAfterClose: onBack,
            })
        }
    }

    const onSubmit = (value: ConsiderationFormType) => {
        setConfigDialog({
            title: translate.get('ALERT.TITLE.NOTIFICATION'),
            content: translate.get('ALERT.CONTENT.NEED_TO_SAVE'),
            type: 'alert-confirm',
            onClickConfirm: () => save(value),
        })

        dialogTwoRef.current?.openDialog()
    }
    const onBack = () => {
        history.goBack()
    }
    return (
        <Container maxWidth="lg">
            <Typography variant="h5" style={{ fontWeight: 'bold', marginBottom: '20px' }}>
                {translate.get('UM.SETTING_CONSIDERATION.EDIT')}
            </Typography>
            <Paper className={classes.paper}>
                <Form onBack={onBack} initialValues={settingConsideration} onSubmit={onSubmit} />
            </Paper>
            <Dialog onRef={onRefDialogTwo} {...configDialog} />
        </Container>
    )
}

const useStyle = makeStyles((theme) => ({
    container: {
        width: '100%',
    },
    paper: {
        width: '100%',
        padding: '20px',

        [theme.breakpoints.down('sm')]: {
            backgroundColor: 'unset',
            boxShadow: 'unset',
            margin: '0px',
        },
    },
}))

export default SettingConsiderationEdit
